import { MenuItem, TextField } from "@mui/material";
import { useQuery } from "react-query";
import API from "../../services/API";

export default function DpcSessionStatus({label, value, onChange}){

    const query = useQuery({
        queryKey: 'dpc_session_status',
        queryFn: () => API.get('/dpc/session/status').then(r => r.data)
    })

    return (query.isSuccess && Array.isArray(query.data)) &&
        
        <TextField
            select
            label={label || ''}
            required
            size="small"
            value={value?.id || 'none'}
            onChange={e => onChange(
                query.data.find(status => status.id === e.target.value) 
                || 
                {id: 'none'}
            )}
            sx={{width: 220}}
        >
            {query.data.map(status =>
                <MenuItem value={status.id} key={status.id}>
                    {status.title || ''}
                </MenuItem>    
            )}
        </TextField>
}